// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {261: "799739c51da1499e",399: "d7880aa6555b56a2",}[chunkId] + ".js"
}